import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative min-h-[100dvh] w-full bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800" }
const _hoisted_2 = { class: "w-full min-h-[100dvh] flex bg-white dark:bg-gray-800" }
const _hoisted_3 = { class: "hidden md:flex w-1/2 bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 items-center justify-center p-8" }
const _hoisted_4 = { class: "text-center text-white space-y-6" }
const _hoisted_5 = { class: "text-3xl font-bold" }
const _hoisted_6 = { class: "h-8 flex items-center justify-center overflow-hidden" }
const _hoisted_7 = { class: "flex flex-col justify-start md:justify-center items-center w-full md:w-1/2 p-5 sm:p-8 lg:p-12 pt-16 sm:pt-20 md:pt-10 relative overflow-y-auto min-h-[100dvh] md:min-h-0" }
const _hoisted_8 = { class: "mb-4 md:hidden flex justify-center pb-4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "w-full max-w-[50rem] space-y-4 md:space-y-8" }
const _hoisted_11 = { class: "bg-white dark:bg-gray-800 p-6 md:p-8 rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-700" }
const _hoisted_12 = {
  key: 0,
  class: "mb-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg"
}
const _hoisted_13 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_14 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_16 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_17 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_18 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_19 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_20 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_21 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_22 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_23 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_24 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_25 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_26 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_27 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_30 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_31 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = ["type"]
const _hoisted_34 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_35 = { class: "relative" }
const _hoisted_36 = ["type"]
const _hoisted_37 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 dark:text-red-400"
}
const _hoisted_38 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useRegistration } from '@/composables/auth/useRegistration'
import { useThemeStore } from '@/stores/theme'
import { Sun, Moon, Eye, EyeOff, LoaderCircle } from 'lucide-vue-next'
import { useToast } from 'vue-toastification'

const toastTimeout = 5000


export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationView',
  setup(__props) {

const toast = useToast()
const appTitle = computed(() => process.env.VUE_APP_TITLE || 'PLANET Home Healthcare')

// Router
const router = useRouter()

const taglines = [
	'Create your account to get started.',
	'Join Our Community',
	'Begin Your Journey',
	'Create Your Future',
	'Start Making a Difference',
]
const currentTagline = ref(0)

// Theme Store
const themeStore = useThemeStore()
const isDarkMode = computed(() => themeStore.isDarkMode)

// Form Fields - Individual Refs (All employee fields)
const firstName = ref('')
const lastName = ref('')
const email = ref('')
const username = ref('')
const phone = ref('')
const dateOfBirth = ref('')
const gender = ref('')
const position = ref('')
const street = ref('')
const city = ref('')
const state = ref('')
const zipcode = ref('')
const password = ref('')
const confirmPassword = ref('')
const termsAgreed = ref(true) // Auto-agree to terms (checkbox removed from UI)
const showPassword = ref(false)
const showConfirmPassword = ref(false)

const usStates = [
	'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
	'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
	'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
	'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
	'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri',
	'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
	'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
	'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
	'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
	'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
]

// Registration Composable - Pass refs as parameter
const {
	loading,
	error,
	success,
	validationErrors,
	handleRegister
} = useRegistration({
	firstName,
	lastName,
	username,
	email,
	phone,
	dateOfBirth,
	gender,
	position,
	street,
	city,
	state,
	zipcode,
	password,
	confirmPassword,
	termsAgreed
})

// Form Submission
const handleSubmit = async () => {
	error.value = ''
	success.value = false

	try {
		const isSuccess = await handleRegister()

		if (isSuccess) {
			toast.success('Registration completed successfully!', {timeout: 2000})
			setTimeout(() => {
				router.push('/login')
			}, 2000)
		} else {
			toast.error(error.value, { timeout: toastTimeout })
		}
	} catch (err: any) {
		error.value = err?.message || 'An error occurred during registration. Please try again.'
	}
}

// Cleanup on mount
onMounted(() => {
	success.value = false
	error.value = ''
})

onMounted(() => {
	setInterval(() => {
		currentTagline.value = (currentTagline.value + 1) % taglines.length
	}, 3500)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("img", {
            src: "images/main-logo-dark.png",
            alt: "App Logo",
            class: "mx-auto h-24 w-[18rem] object-contain drop-shadow-md"
          }, null, -1)),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(appTitle.value), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_Transition, {
              name: "rotate",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("span", {
                  class: "block text-lg font-medium",
                  key: currentTagline.value
                }, _toDisplayString(taglines[currentTagline.value]), 1))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(themeStore).toggleTheme())),
          class: "absolute top-4 right-6 p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition",
          "aria-label": "Toggle dark mode"
        }, [
          (isDarkMode.value)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Sun)), { key: 0 }))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Moon)), { key: 1 }))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: isDarkMode.value ? 'images/main-logo-dark.png' : 'images/main-logo.png',
            alt: "ProWeaver logo",
            class: "h-14 sm:h-16 w-auto object-contain drop-shadow-sm"
          }, null, 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "mb-6" }, [
              _createElementVNode("h1", { class: "text-2xl text-center sm:text-3xl font-bold text-gray-900 dark:text-white" }, "Create an account")
            ], -1)),
            (_unref(success))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("p", { class: "text-green-800 dark:text-green-200 font-medium" }, "Account created successfully! Redirecting to login...", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              class: "space-y-4",
              onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", {
                    for: "firstName",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, [
                    _createTextVNode(" First Name "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "firstName",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
                    type: "text",
                    placeholder: "John",
                    required: "",
                    class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                  }, null, 512), [
                    [_vModelText, firstName.value]
                  ]),
                  (_unref(validationErrors).firstName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(validationErrors).firstName), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", {
                    for: "lastName",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, [
                    _createTextVNode(" Last Name "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "lastName",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
                    type: "text",
                    placeholder: "Doe",
                    required: "",
                    class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                  }, null, 512), [
                    [_vModelText, lastName.value]
                  ]),
                  (_unref(validationErrors).lastName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(validationErrors).lastName), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", {
                    for: "email",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, [
                    _createTextVNode(" Email "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
                    type: "email",
                    placeholder: "john@example.com",
                    required: "",
                    class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                  }, null, 512), [
                    [_vModelText, email.value]
                  ]),
                  (_unref(validationErrors).email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(validationErrors).email), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", {
                    for: "username",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, [
                    _createTextVNode(" Username "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "username",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((username).value = $event)),
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (username.value = $event.target.value.replace(/\s+/g, ''))),
                    type: "text",
                    placeholder: "johndoe",
                    required: "",
                    class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                  }, null, 544), [
                    [_vModelText, username.value]
                  ]),
                  (_unref(validationErrors).username)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(validationErrors).username), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", {
                    for: "phone",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, " Phone Number ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "phone",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((phone).value = $event)),
                    type: "tel",
                    placeholder: "+1 (555) 123-4567",
                    class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                  }, null, 512), [
                    [_vModelText, phone.value]
                  ]),
                  (_unref(validationErrors).phone)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(validationErrors).phone), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", {
                    for: "dateOfBirth",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, " Date of Birth ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "dateOfBirth",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dateOfBirth).value = $event)),
                    type: "date",
                    placeholder: "mm/dd/yyyy",
                    class: _normalizeClass(["date-input block w-full rounded-md border border-gray-300 p-3 bg-gray-50 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-dark dark:focus:border-primary-dark", dateOfBirth.value ? 'text-gray-900 dark:text-white' : 'text-gray-400 dark:text-gray-400 date-empty'])
                  }, null, 2), [
                    [_vModelText, dateOfBirth.value]
                  ]),
                  (_unref(validationErrors).dateOfBirth)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_unref(validationErrors).dateOfBirth), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", {
                    for: "gender",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, " Gender ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "gender",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((gender).value = $event)),
                    class: _normalizeClass(["block w-full rounded-md border border-gray-300 p-3 bg-gray-50 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-dark dark:focus:border-primary-dark", gender.value ? 'text-gray-900 dark:text-white' : 'text-gray-400 dark:text-gray-400'])
                  }, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("option", { value: "" }, "Select Gender", -1),
                    _createElementVNode("option", { value: "male" }, "Male", -1),
                    _createElementVNode("option", { value: "female" }, "Female", -1),
                    _createElementVNode("option", { value: "other" }, "Other", -1)
                  ]))], 2), [
                    [_vModelSelect, gender.value]
                  ]),
                  (_unref(validationErrors).gender)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(validationErrors).gender), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", {
                    for: "position",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, " Position ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "position",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((position).value = $event)),
                    required: "",
                    class: _normalizeClass(["block w-full rounded-md border border-gray-300 p-3 bg-gray-50 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-dark dark:focus:border-primary-dark", position.value ? 'text-gray-900 dark:text-white' : 'text-gray-400 dark:text-gray-400'])
                  }, [...(_cache[28] || (_cache[28] = [
                    _createElementVNode("option", {
                      value: "",
                      Selected: ""
                    }, "Select Position", -1),
                    _createStaticVNode("<option value=\"1\" data-v-18b2dbe4>HHA</option><option value=\"2\" data-v-18b2dbe4>CNA</option><option value=\"3\" data-v-18b2dbe4>PCA</option><option value=\"4\" data-v-18b2dbe4>DSP</option><option value=\"5\" data-v-18b2dbe4>RN</option><option value=\"6\" data-v-18b2dbe4>LPN</option>", 6)
                  ]))], 2), [
                    [_vModelSelect, position.value]
                  ]),
                  (_unref(validationErrors).position)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_unref(validationErrors).position), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[30] || (_cache[30] = _createElementVNode("label", {
                  for: "street",
                  class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                }, " Street Address ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "street",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((street).value = $event)),
                  type: "text",
                  placeholder: "123 Main Street",
                  class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                }, null, 512), [
                  [_vModelText, street.value]
                ]),
                (_unref(validationErrors).street)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_unref(validationErrors).street), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", {
                    for: "city",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, " City ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "city",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((city).value = $event)),
                    type: "text",
                    placeholder: "New York",
                    class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                  }, null, 512), [
                    [_vModelText, city.value]
                  ]),
                  (_unref(validationErrors).city)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_unref(validationErrors).city), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", {
                    for: "state",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, " State ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "state",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((state).value = $event)),
                    class: _normalizeClass(["block w-full rounded-md border border-gray-300 p-3 bg-gray-50 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-dark dark:focus:border-primary-dark", state.value ? 'text-gray-900 dark:text-white' : 'text-gray-400 dark:text-gray-400'])
                  }, [
                    _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "Select a state", -1)),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(usStates, (s) => {
                      return _createElementVNode("option", {
                        key: s,
                        value: s
                      }, _toDisplayString(s), 9, _hoisted_28)
                    }), 64))
                  ], 2), [
                    [_vModelSelect, state.value]
                  ]),
                  (_unref(validationErrors).state)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_unref(validationErrors).state), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", {
                    for: "zipcode",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, " Zipcode ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "zipcode",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((zipcode).value = $event)),
                    type: "text",
                    placeholder: "10001",
                    class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                  }, null, 512), [
                    [_vModelText, zipcode.value]
                  ]),
                  (_unref(validationErrors).zipcode)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_unref(validationErrors).zipcode), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", null, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", {
                    for: "password",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, [
                    _createTextVNode(" Password "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      id: "password",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((password).value = $event)),
                      type: showPassword.value ? 'text' : 'password',
                      placeholder: "Enter password",
                      required: "",
                      minlength: "8",
                      class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark pr-10"
                    }, null, 8, _hoisted_33), [
                      [_vModelDynamic, password.value]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (showPassword.value = !showPassword.value)),
                      class: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(showPassword.value ? _unref(EyeOff) : _unref(Eye)), { class: "h-5 w-5" }))
                    ])
                  ]),
                  (_unref(validationErrors).password)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_unref(validationErrors).password), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", {
                    for: "confirmPassword",
                    class: "block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
                  }, [
                    _createTextVNode(" Confirm Password "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      id: "confirmPassword",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((confirmPassword).value = $event)),
                      type: showConfirmPassword.value ? 'text' : 'password',
                      placeholder: "Confirm password",
                      required: "",
                      minlength: "8",
                      class: "block w-full rounded-md border border-gray-300 p-3 bg-gray-50 text-gray-900 sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark pr-10"
                    }, null, 8, _hoisted_36), [
                      [_vModelDynamic, confirmPassword.value]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                      class: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(showConfirmPassword.value ? _unref(EyeOff) : _unref(Eye)), { class: "h-5 w-5" }))
                    ])
                  ]),
                  (_unref(validationErrors).confirmPassword)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_unref(validationErrors).confirmPassword), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                disabled: _unref(loading),
                class: "w-full flex justify-center py-3 bg-primary text-white font-semibold rounded-lg shadow-md transition hover:bg-primary-hover disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                (_unref(loading))
                  ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                      key: 0,
                      class: "w-5 h-5 mr-2 animate-spin"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_unref(loading) ? 'Creating Account...' : 'Create Account'), 1)
              ], 8, _hoisted_38)
            ], 32),
            _cache[38] || (_cache[38] = _createElementVNode("p", { class: "mt-6 text-sm text-center text-gray-600 dark:text-gray-400" }, [
              _createTextVNode(" Already have an account? "),
              _createElementVNode("a", {
                href: "/portal/login",
                class: "text-primary hover:text-primary-hover dark:text-secondary-dark-text dark:hover:text-secondary-dark-hover font-bold hover:underline"
              }, "Login")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})